import React, { useState } from 'react'
import moment from 'moment'

const SotuMerchants = (props) => {
    const [open, setOpen] = useState(false)

    const getClass = (delta) => {
        return Math.sign(delta) !== -1 ? 'mb-text-sm text-success' : 'mb-text-sm text-danger'
    }

    const { quarter, mer_active_live_offers_count, mer_active_inprogress_offers_count, mer_active_pipeline_nooffers_count, detailed } = props.quarter

    const nextIndex = props.index + 1

    let mer_active_live_offers_delta = 0
    let mer_active_inprogress_offers_delta = 0
    let mer_active_pipeline_nooffers_delta = 0

    if (props.report[nextIndex]) {
        mer_active_live_offers_delta = mer_active_live_offers_count - props.report[nextIndex].mer_active_live_offers_count
        mer_active_inprogress_offers_delta = mer_active_inprogress_offers_count - props.report[nextIndex].mer_active_inprogress_offers_count
        mer_active_pipeline_nooffers_delta = mer_active_pipeline_nooffers_count - props.report[nextIndex].mer_active_pipeline_nooffers_count
    }

    return (
        <React.Fragment>
            <tr>
                <td className="font-weight-bold">{quarter}</td>
                <td className="text-right">
                    {Intl.NumberFormat('en-GB').format(mer_active_live_offers_count)}
                    <div className={getClass(mer_active_live_offers_delta)}>
                        ({Math.sign(mer_active_live_offers_delta) !== -1 && '+'}
                        {Intl.NumberFormat('en-GB').format(mer_active_live_offers_delta)})
                    </div>
                </td>
                <td className="text-right">
                    {Intl.NumberFormat('en-GB').format(mer_active_inprogress_offers_count)}
                    <div className={getClass(mer_active_inprogress_offers_delta)}>
                        ({Math.sign(mer_active_inprogress_offers_delta) !== -1 && '+'}
                        {Intl.NumberFormat('en-GB').format(mer_active_inprogress_offers_delta)})
                    </div>
                </td>
                <td className="text-right">
                    {Intl.NumberFormat('en-GB').format(mer_active_pipeline_nooffers_count)}
                    <div className={getClass(mer_active_pipeline_nooffers_delta)}>
                        ({Math.sign(mer_active_pipeline_nooffers_delta) !== -1 && '+'}
                        {Intl.NumberFormat('en-GB').format(mer_active_pipeline_nooffers_delta)})
                    </div>
                </td>
                <td>
                    <span className="badge badge-primary" style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)}>
                        {open ? '-' : '+'}
                    </span>
                </td>
            </tr>
            {open &&
                detailed.map((record, subIndex) => {
                    let subDelta1 = 0
                    let subDelta2 = 0
                    let subDelta3 = 0
                    const subNextIndex = subIndex + 1

                    if (detailed[subNextIndex]) {
                        subDelta1 = record.mer_active_live_offers_count - detailed[subNextIndex].mer_active_live_offers_count
                        subDelta2 = record.mer_active_inprogress_offers_count - detailed[subNextIndex].mer_active_inprogress_offers_count
                        subDelta3 = record.mer_active_pipeline_nooffers_count - detailed[subNextIndex].mer_active_pipeline_nooffers_count
                    } else {
                        // If there is none, let's jump to the first of the LAST QUARTER
                        if (props.report[nextIndex]) {
                            if (props.report[nextIndex].detailed[0]) {
                                subDelta1 = record.mer_active_live_offers_count - props.report[nextIndex].detailed[0].mer_active_live_offers_count
                                subDelta2 = record.mer_active_inprogress_offers_count - props.report[nextIndex].detailed[0].mer_active_inprogress_offers_count
                                subDelta3 = record.mer_active_pipeline_nooffers_count - props.report[nextIndex].detailed[0].mer_active_pipeline_nooffers_count
                            }
                        }
                    }

                    return (
                        <tr className="text-secondary">
                            <td>
                                <div className="pl-3">{moment(record.date).utc().format('YYYY-MM')}</div>
                            </td>
                            <td className="text-right">
                                {Intl.NumberFormat('en-GB').format(record.mer_active_live_offers_count)}
                                <div className={getClass(subDelta1)}>
                                    ({Math.sign(subDelta1) !== -1 && '+'}
                                    {Intl.NumberFormat('en-GB').format(subDelta1)})
                                </div>
                            </td>
                            <td className="text-right">
                                {Intl.NumberFormat('en-GB').format(record.mer_active_inprogress_offers_count)}
                                <div className={getClass(subDelta2)}>
                                    ({Math.sign(subDelta2) !== -1 && '+'}
                                    {Intl.NumberFormat('en-GB').format(subDelta2)})
                                </div>
                            </td>
                            <td className="text-right">
                                {Intl.NumberFormat('en-GB').format(record.mer_active_pipeline_nooffers_count)}
                                <div className={getClass(subDelta3)}>
                                    ({Math.sign(subDelta3) !== -1 && '+'}
                                    {Intl.NumberFormat('en-GB').format(subDelta3)})
                                </div>
                            </td>
                            <td></td>
                        </tr>
                    )
                })}
        </React.Fragment>
    )
}

export default SotuMerchants
